import React, {Component} from 'react';
import {connect} from 'react-redux';
import {path} from 'ramda';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {changeModalState} from '../../actions/modal'
import './style.css';
import Input from "../../common/Input";
import {validateFields} from "../../utils/validate";
import {
  mergeDeepLeft,
  clone,
} from 'ramda';

class UpdateDurationPopup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      wrapClassName: 'modal-default',
      size: 'default',
      fields: clone({
        hours: {
          label: 'Hours',
          placeholder: 'Fill-in this field.',
          system: {
            component: Input,
            name: 'hours'
          },
          value: '',
          errors: [],
          type: 'number',
          name: 'hours',
          rules: {
            title: 'Hours field',
            required: true,
          }
        },
        minutes: {
          label: 'Minutes',
          placeholder: 'Fill-in this field.',
          system: {
            component: Input,
            name: 'minutes'
          },
          value: '',
          errors: [],
          type: 'number',
          name: 'minutes',
          rules: {
            title: 'Minutes field',
            required: true,
          }
        },
      })
    };

    this.toggle = this.toggle.bind(this);
    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
  }

  componentWillReceiveProps(newProps) {
    let duration = path(['modal', 'duration'], newProps);
    if (duration > 60) {
      const durationHour = Math.floor(duration/3600);
      const durationMins = Math.floor((duration - durationHour*3600)/60);
      if (this.state.fields['hours'].value !== durationHour
        && this.state.fields['minutes'].value !== durationMins) {
        let stateClone = clone(this.state);
        stateClone.fields['hours'].value = durationHour > 0 ? durationHour : '';
        stateClone.fields['minutes'].value = durationMins > 0 ? durationMins : '';
        this.setState(mergeDeepLeft(stateClone, this.state));
      }
    } else {
      this.clearFields();
    }
  }

  toggle() {
    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen
    });
  }

  clearFields() {
    let stateClone = clone(this.state);
    for (let i in stateClone.fields) {
      stateClone.fields[i].value = "";
    }
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.clearFields();
    this.toggle();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field === 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const id = path(['modal', 'id'], this.props);
      let handler = path(['modal', 'handler'], this.props);

      let hours = parseInt(result.fields['hours'].value) || 0;
      let minutes = parseInt(result.fields['minutes'].value) || 0;
      let duration = ((hours*60) + minutes)*60;
      this.props.makeActionById({id: id, duration: duration}, handler);
      this.toggle();
    }
    return false;
  }

  render() {
    let modalId = path(['modal', 'modalId'], this.props);
    let showModal = this.props.modal.isOpen;
    if (modalId && modalId !== this.props.id) {
      showModal = false;
    }

    return (
      <Modal
        isOpen={showModal}
        toggle={this.toggle}
        wrapClassName={this.state.wrapClassName}
        size={this.state.size}
      >

        <ModalHeader>Please enter the correct duration</ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={this.submit}>
              <Input
                field={this.state.fields['hours']}
                onChange={this.changeFormValue}
              />
              <Input
                field={this.state.fields['minutes']}
                onChange={this.changeFormValue}
              />
            </form>
          </div>
          <div className="clearfix pull-right">
            <button className="btn btn-default mr-1" onClick={this.cancel}>
              Cancel
            </button>
            <button className="btn btn-default" onClick={this.submit}>
              Update
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    makeActionById: (data, handler) => {
      if (typeof handler(data) == 'function') {
        handler(data)(dispatch);
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDurationPopup);



// WEBPACK FOOTER //
// ./src/containers/Reports/updateDurationPopup.js